export const formatSigFig = (num: number, figures = 3) => {
  if (num === 0) return '0'

  const abs = Math.abs(num)

  if (abs < 0.1) {
    const fixed = num.toFixed(figures)

    return Number(fixed) === 0 ? fixed.replace('-', '') : fixed
  }

  const rounded = Math.abs(Number(num.toPrecision(figures)))

  const { divisor, suffix } =
    rounded >= 1_000_000
      ? { divisor: 1_000_000, suffix: 'M' }
      : rounded >= 1_000
        ? { divisor: 1_000, suffix: 'K' }
        : { divisor: 1, suffix: '' }

  const formatted = Number((num / divisor).toPrecision(figures)).toString()

  return formatted + suffix
}
